import { Component, Input, OnChanges, HostBinding, SimpleChanges } from '@angular/core';

import svg4everybody from 'svg4everybody';
svg4everybody();

@Component({
  selector: 'ula-svg-icon',
  templateUrl: './ula-svg-icon.component.html',
  styleUrls: [ './ula-svg-icon.component.css' ]
})
export class UlaSvgIconComponent implements OnChanges {
  @Input('class') public classList: string = '';
  @Input() public iconId: string;
  @Input() public path: string;

  /**
   * Width & Height
   * @param width: number = width of the actual svg artwork being shown
   * @param height: number = height of the actual svg artwork being shown
   *
   * @NOTE: width & height are not to resize your svg, but to position it.
   * this utility will automatically center any svgs it displays, BUT
   * will not scale your svgs to that width (to scale you must use viewBox)
   *
   * if your SVG looks off center, or is not aligning properly, you need
   * to set these values.
   */
  @Input() public height: string = '100%';
  @Input() public width: string = '100%';

  /**
   * SVG ViewBox
   * https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/viewBox
   * https://www.sarasoueidan.com/blog/svg-coordinate-systems/
   *
   * @param viewBox: string = "<left-edge|offsetX> <top-edge|offsetY> <width|boxX> <height|boxY>"
   * @param offsetX: number = <left-edge of artwork>
   * @param offsetY: number = <top-edge of artwork>
   * @param boxX: number = <width of artwork>
   * @param boxY: number = <height of artwork>
   *
   * @NOTE: if your SVG is too small or is weirdly cropped, you need to adjust the
   * viewBox, which is a somewhat complicated implementation of an Artboard.
   * if the resources above do not help you, contact Nathan Walston on slack.
   */
  @Input() public viewBox: string;
  @Input() public offsetX: number;
  @Input() public offsetY: number;
  @Input() public boxX: number;
  @Input() public boxY: number;

  private defaultClassName = 'ula-center-bounds';
  @HostBinding() private className: string = this.defaultClassName;

  private iconBasePath: string = 'assets/svgs/svgs.svg';

  ngOnChanges(
    { iconId, classList, offsetX, offsetY, boxX, boxY, viewBox }: SimpleChanges
  ): void {
    if (classList) {
      this.setClassName();
    }

    if (iconId) {
      this.setIconPath();
    }

    if (!viewBox && offsetX && offsetY && boxX && boxY) {
      this.setViewBox();
    }
  }

  private setClassName(): void {
    this.className = `${ this.defaultClassName } ${ this.classList }`;
  }

  private setIconPath(): void {
    this.path = this.iconBasePath + '#' + this.iconId;
  }

  // Would want to make use of this when not explicitly declaring this on the
  // the symbol - in case this needs to be dynamic.
  private setViewBox(): void {
    this.viewBox = `${ this.offsetX } ${ this.offsetY } ${ this.boxX } ${ this.boxY }`;
  }
}
